export default "__VITE_ASSET__Dy_4RlnL__"